import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Lock } from 'lucide-react';
export function Login() {
  const [isSignUp, setIsSignUp] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="w-full min-h-screen bg-white flex items-center justify-center px-6 py-32" data-id="element-242">
      <div className="w-full max-w-md" data-id="element-243">
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center mb-12" data-id="element-244">
          <h1 className="text-4xl md:text-5xl font-serif text-zinc-950 mb-4" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-245">
            {isSignUp ? 'Create Account' : 'Welcome Back'}
          </h1>
          <p className="text-zinc-600" data-id="element-246">
            {isSignUp ? 'Begin your wellness journey' : 'Access your cellular health portal'}
          </p>
        </motion.div>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="bg-zinc-50 p-8 md:p-12 border border-zinc-200" data-id="element-247">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-248">
            {isSignUp && <div data-id="element-249">
                <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-250">
                  Full Name
                </label>
                <input type="text" required value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} className="w-full px-4 py-3 border border-zinc-300 bg-white focus:border-zinc-950 focus:outline-none transition-colors" placeholder="Enter your name" data-id="element-251" />
              </div>}

            <div data-id="element-252">
              <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-253">
                Email Address
              </label>
              <div className="relative" data-id="element-254">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" strokeWidth={1.5} data-id="element-255" />
                <input type="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full pl-12 pr-4 py-3 border border-zinc-300 bg-white focus:border-zinc-950 focus:outline-none transition-colors" placeholder="your@email.com" data-id="element-256" />
              </div>
            </div>

            <div data-id="element-257">
              <label className="block text-sm tracking-[0.2em] uppercase text-zinc-600 mb-3" data-id="element-258">
                Password
              </label>
              <div className="relative" data-id="element-259">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" strokeWidth={1.5} data-id="element-260" />
                <input type="password" required value={formData.password} onChange={e => setFormData({
                ...formData,
                password: e.target.value
              })} className="w-full pl-12 pr-4 py-3 border border-zinc-300 bg-white focus:border-zinc-950 focus:outline-none transition-colors" placeholder="Enter your password" data-id="element-261" />
              </div>
            </div>

            {!isSignUp && <div className="flex justify-end" data-id="element-262">
                <button type="button" className="text-sm text-zinc-600 hover:text-zinc-950 transition-colors" data-id="element-263">
                  Forgot password?
                </button>
              </div>}

            <button type="submit" className="w-full px-8 py-3 bg-zinc-950 text-white text-sm tracking-[0.2em] uppercase font-medium hover:bg-zinc-800 transition-colors duration-300" data-id="element-264">
              {isSignUp ? 'Create Account' : 'Sign In'}
            </button>
          </form>

          <div className="mt-8 text-center" data-id="element-265">
            <button onClick={() => setIsSignUp(!isSignUp)} className="text-sm text-zinc-600 hover:text-zinc-950 transition-colors" data-id="element-266">
              {isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
            </button>
          </div>
        </motion.div>
      </div>
    </motion.div>;
}